import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeExcelSvg } from './NeExcelSvg'

export const NeExcelIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeExcelSvg} {...props} />
}
